import { useDispatch, useSelector } from "react-redux";
import { useDialogs } from "@toolpad/core/useDialogs";

import { RootState } from "@store/store";
import { setApplicationSelected } from "@store/slices/componentsSlice";
import { Notificacion } from "@components/DialogosSegmentos/Notificacion";
import {
    usePostStatusApplicationMutation,
    useLazyGetApplicationResumeByCompanyIdQuery,
} from "@services/api/applications";
import { useLazyGetTaxSystemQuery } from "@services/api/catalogs";
import { omit } from "@helpers/generals";
import { Application, ApplicationMarketplaceResume, ApplicationResume } from "@interfaces/application";

export function useChangeStatusApp() {
    const dialogs = useDialogs();
    const dispatch = useDispatch();

    const userSession = useSelector((state: RootState) => state.session.user);
    const applicationSelected = useSelector((state: RootState) => state.components.applicationSelected);

    const [triggerGetTaxSystemInfo] = useLazyGetTaxSystemQuery();
    const [triggerGetAppInfo] = useLazyGetApplicationResumeByCompanyIdQuery();
    const [triggerPostStatusApplication] = usePostStatusApplicationMutation();

    const updateStatusApp = async (
        status: string,
        disableSequenceCheck: boolean | undefined = undefined,
        updateStore: boolean = true,
    ): Promise<ApplicationResume | ApplicationMarketplaceResume | void> => {
        try {
            await triggerPostStatusApplication({
                applicationId: applicationSelected.id,
                userName:
                    userSession.name
                        ?.concat(" ", userSession.last_name ?? "", " ", userSession.last_name_2 ?? "")
                        .trim() ?? "",
                statusCode: status,
                disableSequenceCheck: disableSequenceCheck,
            }).unwrap();

            const updatedApp = await triggerGetAppInfo({
                companyId: Number(applicationSelected.id_application_company),
                params: new URLSearchParams([
                    ["company_source", applicationSelected.company_source?.toUpperCase() as string],
                ]).toString(),
            }).unwrap();

            const taxSystemInfo = await triggerGetTaxSystemInfo(updatedApp.tax_system.id).unwrap();

            if (updatedApp && updateStore == true) {
                dispatch(
                    setApplicationSelected({
                        ...updatedApp,
                        tax_system: {
                            ...updatedApp.tax_system,
                            config_extra: omit(taxSystemInfo.config_extra, ["bpm_lateral_options"]),
                        },
                    }),
                );
            } else if (updatedApp && updateStore == false) {
                return {
                    ...updatedApp,
                    tax_system: {
                        ...updatedApp.tax_system,
                        config_extra: omit(taxSystemInfo.config_extra, ["bpm_lateral_options"]),
                    },
                };
            }
        } catch (error) {
            dialogs.open(Notificacion, {
                type: "WARNING",
                text: "Ocurrio un error al cambiar el estado de la solicitud",
            });
            return undefined;
        }

        // triggerPostStatusApplication({
        //     applicationId: applicationSelected.id,
        //     userName:
        //         userSession.name?.concat(" ", userSession.last_name ?? "", " ", userSession.last_name_2 ?? "").trim() ??
        //         "",
        //     statusCode: status,
        //     disableSequenceCheck: disableSequenceCheck,
        // })
        //     .then((_) => {
        //         triggerGetAppInfo({
        //             companyId: Number(applicationSelected.id_application_company),
        //             params: new URLSearchParams([
        //                 ["company_source", applicationSelected.company_source?.toUpperCase() as string],
        //             ]).toString(),
        //         }).then((result) => {
        //             triggerGetTaxSystemInfo(applicationSelected.tax_system.id).then((taxSystemResult) => {
        //                 const updatedApp = result.data;
        //                 if (updatedApp)
        //                     dispatch(
        //                         setApplicationSelected({
        //                             ...updatedApp,
        //                             tax_system: {
        //                                 ...updatedApp.tax_system,
        //                                 config_extra: omit(taxSystemResult.data?.config_extra, ["bpm_lateral_options"]),
        //                             },
        //                         }),
        //                     );
        //             });
        //         });
        //     })
        //     .catch((error) => {
        //         dialogs.open(Notificacion, {
        //             type: "WARNING",
        //             text: "Ocurrio un error al cambiar el estado de la solicitud",
        //         });
        //     });
    };

    return { updateStatusApp };
}
